import activity from './activity/reducer';
import user from './user/reducer';
import consumerUsers from './patients/reducer';


export default {
    activity,
    user,
    consumerUsers,
};